import { Controller } from "@hotwired/stimulus"
import { pluralize, escapeHtml } from "../util"

export default class extends Controller {
  static targets = ["panel", "source", "destination", "targetTag", "mergeBtn"]
  static values = {
    data: {
      type: Array,
      default: []
    }
  }

  selectedTag = null
  TAG_KINDS = {
    source: "source",
    destination: "destination"
  }

  primaryTagSelectChanged(event) {
    const selectedTagValue = event.target.value

    if (!selectedTagValue) {
      this.panelTarget.classList.add("hidden")
      this.targetTagTarget.textContent = ""
      this.mergeBtnTarget.disabled = true
      return
    }

    this.selectedTag = this.dataValue.find(tag => tag.value === +selectedTagValue)

    this.sourceTarget.innerHTML = this.generateSourceHtml()
    this.destinationTarget.innerHTML = this.generateDestinationHtml()

    this.panelTarget.classList.remove("hidden")
    this.targetTagTarget.textContent = this.selectedTag?.label || "Unknown Tag"
    this.mergeBtnTarget.disabled = false
  }

  generateSourceHtml() {
    return this.dataValue
      .map(tag => {
        const ambassadorsCount = tag.entities.users?.count || 0
        const contentCount = Object.entries(tag.entities)
          .filter(([key]) => key !== "users")
          .reduce((sum, [, entity]) => sum + (entity?.count || 0), 0)

          return this.getTagHtml(this.TAG_KINDS.source, tag.label, ambassadorsCount, contentCount)
      })
      .join('')
  }

  generateDestinationHtml() {
    const uniqueUserIds = new Set()
    const uniqueContentIds = new Set()

    this.dataValue.forEach(tag => {
      Object.entries(tag.entities)
        .forEach(([key, entity]) => {
          entity.ids.forEach(id => {
            if (key === "users") {
              uniqueUserIds.add(id)
            } else {
              uniqueContentIds.add(id)
            }
          })
        })
    })

    const ambassadorsCount = uniqueUserIds.size
    const contentCount = uniqueContentIds.size

    return this.getTagHtml(this.TAG_KINDS.destination, this.selectedTag.label, ambassadorsCount, contentCount)
  }

  getTagHtml(kind, label, ambassadorsCount, contentCount) {
    const wrapperClass = {
      source: "bg-seasalt-200",
      destination: "bg-forestgreen/10 border border-forestgreen/70"
    }

    const labelClass = {
      source: "",
      destination: "text-forestgreen"
    }

    const textClass = {
      source: "text-seasalt-500",
      destination: "text-forestgreen/70"
    }

    return `
      <div class="flex flex-col gap-5 p-12 ${wrapperClass[kind]} rounded-8">
        <div class="${labelClass[kind]} font-medium leading-20">${escapeHtml(label)}</div>
        <div class="${textClass[kind]} text-12 font-medium leading-16">
          ${pluralize(ambassadorsCount, 'ambassador', 'ambassadors')},
          ${pluralize(contentCount, 'item', 'items')}
        </div>
      </div>
    `
  }

  clearSelectedCheckboxes() {
    const customEvent = new CustomEvent('table-checkboxes:clear', { bubbles: true })
    this.element.dispatchEvent(customEvent)
  }
}
